import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-wDUGk-PaktDJuArehYZSdBpHX7aV6VI",
  authDomain: "dt-qr-locker.firebaseapp.com",
  projectId: "dt-qr-locker",
  storageBucket: "dt-qr-locker.firebasestorage.app",
  messagingSenderId: "64566679570",
  appId: "1:64566679570:web:b35394f2bd24f20c5b60cb",
  measurementId: "G-88GNWWRBPK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics (optional - for tracking usage)
export const analytics = getAnalytics(app);

export default app; 